export default "//file.bilionpass.com/japandx-portal/0.1.22/static/img/related-arrow.6ef96e9d-8e3bc5.svg";